export * from './lookup-table.component';
